import {useFormContext} from "react-hook-form";

import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {PasswordInput} from "@/components/passwordInput/PasswordInput.tsx";
import {FieldProps} from "@/pages/checks/components/form/fields/common.ts";

interface Props extends FieldProps {
  hideMaskButtonNoValue?: boolean;
  autoComplete?: string;
}

export const PasswordField = ({
  name,
  hideMaskButtonNoValue = false,
  required,
  placeholder,
  autoComplete,
  ...rest
}: Props) => {
  const {register, watch} = useFormContext();
  const value = watch(name);
  const hideMaskButton = hideMaskButtonNoValue && !value && !!placeholder;
  const extraOptions: Record<string, string> = {};
  if (required) {
    extraOptions["required"] = "This field is required";
  }
  return (
    <InputField
      name={name}
      placeholder={placeholder}
      required={required}
      {...rest}
      input={
        <PasswordInput hideMaskButton={hideMaskButton} {...register(name, extraOptions)} autoComplete={autoComplete} />
      }
    />
  );
};
